import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-create-edit-version-dialog',
  templateUrl: 'create-edit-version-dialog.component.html',
  standalone: false,
})
export class CreateEditVersionDialogComponent {
  version = '';
  semanticVersioningOk = false;
  isEdit = false;

  constructor(
    public dialogRef: MatDialogRef<CreateEditVersionDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      isEdit: boolean;
      version: string;
    },
  ) {
    this.isEdit = data.isEdit;
    this.version = data.version ? data.version : '';
  }

  testFormat(): void {
    const regex = new RegExp(/^([0-9]+)\.([0-9]+)\.([0-9]+)$/);
    this.semanticVersioningOk = regex.test(this.version);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  submitSelection(): void {
    this.dialogRef.close(this.version);
  }
}
